import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { primerParrafoHtml } from '../utils/texto';

const NewspaperLayoutInv = ({ newsData, categoriesData }) => {
  const [mainNews, setMainNews] = useState(null);
  const [rightColumns, setRightColumns] = useState({ two: null, three: null });
  const [categoryStyles, setCategoryStyles] = useState({ line: '', category: '', button: '' });
  const [categoryName, setCategoryName] = useState('');
  const [textColor, setTextColor] = useState('#000');

  useEffect(() => {
    if (!newsData || newsData.length === 0) return;

    const getLatestByNumber = (numberValue) => {
      const filtered = newsData
        .filter(news => news.number === numberValue)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      return filtered[0] || null;
    };

    const first = getLatestByNumber(1);
    const second = getLatestByNumber(2);
    const third = getLatestByNumber(3);

    setMainNews(first);
    setRightColumns({ two: second, three: third });

    const getCategoryColorAndName = (newsItem) => {
      const category = categoriesData?.find(cat => cat.id === newsItem?.category_id);
      return category
        ? { color: category.color, name: category.name }
        : { color: '#000', name: '' };
    };

    if (first) {
      const { color, name } = getCategoryColorAndName(first);
      setCategoryStyles({
        line: color,
        category: color,
        button: color,
      });
      setCategoryName(name);

      const isLightColor = (hex) => {
        if (!hex || typeof hex !== 'string') return true;
        const matches = hex.match(/\w\w/g);
        if (!matches || matches.length < 3) return true;
        const rgb = matches.map(x => parseInt(x, 16));
        const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return brightness > 128;
      };

      setTextColor(isLightColor(color) ? '#000' : '#fff');
    }
  }, [newsData, categoriesData]);

  // Devuelve siempre un string seguro para dangerouslySetInnerHTML.
  // Si el body no existe o está vacío, devuelve cadena vacía — no 'undefined'.

  const esNoticiaCentral105 = (news) =>
  news?.title?.toLowerCase().includes('central 105');
  return (
    <>
      <div className='line_space'>
        <hr className='line' style={{ borderColor: categoryStyles.line }} />
      </div>

      <div
        className='news_category'
        style={{
          backgroundColor: categoryStyles.category,
          color: textColor,
          fontFamily: 'Libre Baskerville',
          fontSize: '0.8rem',
        }}
      >
        {categoryName || 'Categoría'}
      </div>

      <div className="columns-container-principal">
        <div className="right-column">
          {rightColumns.two && (
            <div className="column-right">
              <Link to={`/noticias/${rightColumns.two.id}`} className="news-card-link">
                <img
                  src={rightColumns.two.image_url}
                  alt="Noticia 2"
                  className={`main-news-image ${esNoticiaCentral105(mainNews) ? 'imagen-central105' : ''}`}
                  loading="lazy"
                  decoding="async"
                />
                <h2>{rightColumns.two.title}</h2>
                {/* <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.two.body) }} /> */}
                <div className="columns-container">
                  <span
                    className='button_categorias'
                    style={{ backgroundColor: categoryStyles.button, color: textColor }}
                  >
                    Ver más
                  </span>
                </div>
              </Link>
            </div>
          )}
          {rightColumns.three && (
            <div className="column-right">
              <Link to={`/noticias/${rightColumns.three.id}`} className="news-card-link">
                <img
                  src={rightColumns.three.image_url}
                  alt="Noticia 3"
                  className={`right-column-image ${esNoticiaCentral105(rightColumns.two) ? 'imagen-central105' : ''}`}
                  loading="lazy"
                  decoding="async"
                />
                <h2>{rightColumns.three.title}</h2>
                {/* <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.three.body) }} /> */}
                <div className="columns-container">
                  <span
                    className='button_categorias'
                    style={{ backgroundColor: categoryStyles.button, color: textColor }}
                  >
                    Ver más
                  </span>
                </div>
              </Link>
            </div>
          )}
        </div>

        {mainNews && (
          <div className="main-news">
            <Link to={`/noticias/${mainNews.id}`} className="news-card-link">
              <img
                src={mainNews.image_url}
                alt={mainNews.title}
                className="main-news-image"
                loading="lazy"
                decoding="async"
              />
              <h2>{mainNews.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: primerParrafoHtml(mainNews.body) }} />
              <div className="columns-container">
                <span
                  className='button_categorias'
                  style={{ backgroundColor: categoryStyles.button, color: textColor }}
                >
                  Ver más
                </span>
              </div>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default NewspaperLayoutInv;